import type { ChartHistoryFilterType } from "@roman/shared/constants/predictionChart";
import {
  type ChartDataPoint,
  getCustomTicksFor1M,
  getCustomTicksFor1W,
  getCustomTicksForAll,
  getTickInterval,
  getXAxisFormatter,
} from "@roman/shared/features/chart";
import { XAxis } from "recharts";

interface CreateXAxisProps {
  chartData: ChartDataPoint[];
  displayMode: ChartHistoryFilterType;
}

/**
 * XAxisコンポーネントを生成する関数
 * 複雑なticks計算とinterval計算を内部で行う
 */
export const createXAxis = ({ chartData, displayMode }: CreateXAxisProps) => {
  // Calculate custom ticks based on display mode
  const getCustomTicks = () => {
    switch (displayMode) {
      case "all":
        return getCustomTicksForAll(chartData, displayMode);
      case "1M":
        return getCustomTicksFor1M(chartData, displayMode);
      case "1W":
        return getCustomTicksFor1W(chartData, displayMode);
      default:
        return undefined;
    }
  };

  // Calculate interval based on display mode
  const getInterval = () => {
    if (displayMode === "all" || displayMode === "1M" || displayMode === "1W") {
      return "preserveStartEnd";
    }
    return getTickInterval(chartData.length);
  };

  return (
    <XAxis
      dataKey="time"
      stroke="#888888"
      fontSize={12}
      tickLine={false}
      axisLine={false}
      textAnchor="middle"
      tickFormatter={(value) => getXAxisFormatter(value, displayMode)}
      interval={getInterval()}
      ticks={getCustomTicks()}
    />
  );
};
